import React from "react";
import { Layout } from "antd";
import { useOutlet } from "react-router-dom";

import AppSider from "components/app-sider/app-sider";
import MobileHeader from "components/mobile-header/mobile-header";
import { useUiStatus } from "state/reactive-vars/ui-status-var";
import { voidFnc } from "utils/helpers";

const AnonNavigationLayout: React.FC = () => {
  const { uiStatusValue, updateUiStatus } = useUiStatus();
  const { loggedSidebarCollapsed } = uiStatusValue;
  const outlet = useOutlet();

  return (
    <div className="logged-nav-container">
      <Layout className="logged-nav-layout">
        <AppSider
          isCollapsed={!!loggedSidebarCollapsed}
          menuItems={[]} // No menu items for anonymous users
          selectedKey=""
          handleOnCollapse={(collapsed) => {
            updateUiStatus({
              loggedSidebarCollapsed: collapsed,
            });
          }}
          toggle={() => {
            updateUiStatus({
              loggedSidebarCollapsed: !loggedSidebarCollapsed,
            });
          }}
          handleClose={() => {
            updateUiStatus({
              loggedSidebarCollapsed: true,
            });
          }}
          handleOnClickLogo={voidFnc}
        />
        <div className="logged-nav-content">
          <MobileHeader />
          <div className="logged-nav-screen">{outlet}</div>
        </div>
      </Layout>
    </div>
  );
};

export default AnonNavigationLayout;